import { FC } from 'react';
import { CatToggle } from '@blocks-react/components/Toggle';
import { CatHeading } from '@blocks-react/components/Heading';
import { IncludeDismissedNotificationProps } from '../types';

export const IncludeDismissedNotifications: FC<
  IncludeDismissedNotificationProps
> = ({ includeDismissedNotifications, handleToggleChange, title }) => {
  return (
    <>
      <CatToggle
        hideLabel={true}
        checked={includeDismissedNotifications}
        onBlToggleChange={handleToggleChange}
        aria-label={title}
        data-testid="include-dismissed-notifications"
      />
      <CatHeading variant="body-sm">{title}</CatHeading>
    </>
  );
};
